import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment/moment';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppInformationService } from './app-information.service';
import { SessionInformationService } from './session-information.service';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    static serviceName: string;
    static controllerName: string = 'dashboard';

    constructor(private http: HttpClient, private appInfo: AppInformationService, private sessionInfo: SessionInformationService) {
        DashboardService.serviceName = environment.serviceName;
    }

    async getDashboardInfos(startDate: Date, endDate: Date) {
        const start = moment(startDate).startOf('day').toDate();
        const end = moment(endDate).endOf('day').toDate();
        const result = await firstValueFrom(
            this.http.post(`${DashboardService.serviceName}/${DashboardService.controllerName}/getDashboardInfos`, {
                startDate: start,
                endDate: end
            })
        );
        return result;
    }
    async getAverageLoadTimes(startDate: Date, endDate: Date) {
        const start = moment(startDate).startOf('day').toDate();
        const end = moment(endDate).endOf('day').toDate();
        const result = await firstValueFrom(
            this.http.post(`${DashboardService.serviceName}/${DashboardService.controllerName}/getAverageLoadTimes`, {
                startDate: start,
                endDate: end
            })
        );
        return result;
    }

    async getDumpstersOnSite(startDate: Date, endDate: Date) {
        const start = moment(startDate).startOf('day').toDate();
        const end = moment(endDate).endOf('day').toDate();
        const result = await firstValueFrom(
            this.http.post(`${DashboardService.serviceName}/${DashboardService.controllerName}/getDumpstersOnSite`, {
                startDate: start,
                endDate: end
            })
        );
        return result;
    }

    async getInvoiceDashboard(startDate: Date, endDate: Date) {
        const start = moment(startDate).startOf('day').toDate();
        const end = moment(endDate).endOf('day').toDate();
        const result = await firstValueFrom(
            this.http.post(`${DashboardService.serviceName}/${DashboardService.controllerName}/getInvoiceDashboard`, {
                startDate: start,
                endDate: end
            })
        );
        return result;
    }

    async getAvailabilityInfos(startDate: Date, endDate: Date) {
        const start = moment(startDate).startOf('day').toDate();
        const end = moment(endDate).endOf('day').toDate();
        const result = await firstValueFrom(
            this.http.post(`${DashboardService.serviceName}/${DashboardService.controllerName}/getAvailabilityInfos`, {
                startDate: start,
                endDate: end
            })
        );
        return result;
    }

    async getDumpsterAverageMargins(startDate: Date, endDate: Date) {
        const start = moment(startDate).startOf('day').toDate();
        const end = moment(endDate).endOf('day').toDate();
        const result = await firstValueFrom(
            this.http.post(`${DashboardService.serviceName}/${DashboardService.controllerName}/getDumpsterAverageMargins`, {
                startDate: start,
                endDate: end
            })
        );
        return result;
    }

    async getSubbedDumpsters(startDate: Date, endDate: Date) {
        const start = moment(startDate).startOf('day').toDate();
        const end = moment(endDate).endOf('day').toDate();
        const result = await firstValueFrom(
            this.http.post(`${DashboardService.serviceName}/${DashboardService.controllerName}/getSubbedDumpsters`, {
                startDate: start,
                endDate: end
            })
        );
        return result;
    }

    async getLostJobsByDumpster(startDate: Date, endDate: Date) {
        const start = moment(startDate).startOf('day').toDate();
        const end = moment(endDate).endOf('day').toDate();
        const result = await firstValueFrom(
            this.http.post(`${DashboardService.serviceName}/${DashboardService.controllerName}/getLostJobsByDumpster`, {
                startDate: start,
                endDate: end
            })
        );
        return result;
    }
}
